export default "__VITE_ASSET__CRrrflP5__"